import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { ensureShopSession } from "@/lib/api";

export function RequireShopAuth() {
  const location = useLocation();
  const [ready, setReady] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    let cancelled = false;
    void ensureShopSession().then((ok) => {
      if (cancelled) return;
      setAuthenticated(ok);
      setReady(true);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!ready) {
    return (
      <div className="shop-page flex min-h-[40vh] items-center justify-center text-sm text-slate-500">
        Sitzung wird geprüft…
      </div>
    );
  }

  if (!authenticated) {
    return <Navigate to="/login" replace state={{ returnTo: location.pathname }} />;
  }

  return <Outlet />;
}
